export const RelationTypes = {
  self: 'self',
  admins: 'admins',
  basics: 'basics',
  manager: 'manager',
  managers: 'managers',
  everyone: 'everyone',
  teamLead: 'team_lead',
  employeesTeamLead: 'employees_team_lead',
  timeoff_manager: 'timeoff_manager',
  notifiable: 'notifiable',
}

export const NotifiableTypes = {
  team: 'Team',
  access: 'Access',
  location: 'Location',
  permissionGroup: 'Permissions::Group',
  legalEntity: 'LegalEntity',
}
